import myAxios from '../utils/request.js';

export default {
    // 报告分类
    // 查询我的团队
    async queryTeamList(query) {
        let res = await myAxios.getJson('/team/queryList',query)
        return res.data;
    },
    // 新增团队
    async addTeam(data) {
        let res = await myAxios.postJson('/team',data)
        return res.data;
    },
    
    // 修改团队
    async updateTeam(data) {
        let res = await myAxios.putJson('/team',data)
        return res.data;
    },

    // 删除团队
    async delTeam(query) {
        let res = await myAxios.getJson('/team/remove', query)
        return res.data;
    },

    // 删除团队
    async getTeamDetails(id) {
        let res = await myAxios.getJson('/team/'+id,)
        return res.data;
    },

    // 分页查询团队成员
    async getTeamUser(params={}, cb) {
        let res = await myAxios.postJson('/team/pageTeamUser',params)
        return res.data;
    },

    // 分页查询所有成员（用于选人）
    async getAllTeamUser(data) {
        let res = await myAxios.postJson('/team/pageAllTeamUser',data)
        return res.data;
    },

    // 批量添加团队成员
    async addTeamUser(data) {
        let res = await myAxios.postJson('/team/insertBatchTeamUser',data)
        return res.data;
    },

    // 批量删除团队成员
    async deleteTeamUser(data) {
        let res = await myAxios.postJson('/team/deleteBatchTeamUser',data)
        return res.data;
    },

    // 根据团队id、用户id修改权限
    async updateTeamUserPerm(data) {
        let res = await myAxios.postJson('/team/updateTeamUserPerm',data)
        return res.data;
    },
}

